export const GridFiltersFormFields = {
	keyword: 'keyword',
	gender: 'gender',
	fromAge: 'minAge',
	toAge: 'maxAge',
	createdBy: 'createdBy',
} as const;

export const GridFiltersQueryParams = {
	page: 'page',
	keyword: 'keyword',
	gender: 'gender',
	fromAge: 'minAge',
	toAge: 'maxAge',
	createdBy: 'createdBy',
} as const;
